import React, { useState } from 'react';
import { sendTestEmailApi } from '../../http/userAPI';
import { Form, Button, Row, Col } from 'react-bootstrap';

const emailQueue = [
    { template: 'queue_email_1', subject: '9 Reasons Why Virtalibry Is More Than Just a Review Platform' },
    { template: 'queue_email_2', subject: 'How to Start Earning Reviews on Virtalibry the Right Way' },
    { template: 'queue_email_3', subject: 'Boost Your Book Sales with the Right Cover, Title, and Description' },
    { template: 'queue_email_4', subject: 'Find the Best Book Deals Fast with Our Powerful Filters' },
    { template: 'queue_email_5', subject: 'How Country-Specific Review Targeting Works' },
    { template: 'queue_email_6', subject: 'Work Smarter: Transfer Virts Between Your Own Accounts' },
    { template: 'queue_email_7', subject: 'Unlock Extra Earnings with the Virtalibry Affiliate Program' },
    { template: 'queue_email_8', subject: 'Your Ideas Matter — Help Shape Virtalibry’s Future!' },
    { template: 'queue_email_9', subject: 'Keep Reviews High-Quality — Rate, Refine, Improve!' },
    { template: 'queue_email_10', subject: 'Exclusive 30% Discount Just for You — Upgrade Today!' },
    { template: 'queue_email_11', subject: '🚀 Super Deal: 50% Off Your First Year — Don’t Miss Out!' },
    { template: 'assignment_auto_check', subject: 'Boom! A Fresh New Review Just Landed on Your Book!' },
    { template: 'promo_code_request', subject: 'Your Promo Code Request was Received' },
    { template: 'review_online_3_days', subject: 'Your Review Offer Hasn’t Been Claimed in 3 Days — Let’s Fix That' },
    { template: 'subscription_expired', subject: 'Action Required: Payment Issue with Your Virtalibry Subscription' },

];

const emailTemplates = [
    'welcome',
    'assignment_auto_check',
    'review_is_due_today',
    'review_cancelled',
    'review_follow_up',
    'review_verification',
    'review_not_verified',
    'payok',
    'add_funds_ok',
    'add_funds_ok_partner',
    'payment_failed',
    'ver_code',
    'transfer_ok',
    'new_referral',
    'promo_code_request',
    'review_online_3_days',
    'subscription_expired',
    ...emailQueue.map(e => e.template),
    'custom'
];

const testEmails = [
    'pakr@ukr.net',
    'pakr@mail.ru',
    '7ink.biz@gmail.com',
    'kravtsovpavel@gmail.com',
];

const testUsernames = [
    'Piter',
    'User',
    'Charodey',
    'Ivan Inanovitch Ivanov'
];

const TestEmailSender = () => {
    const [selectedEmail, setSelectedEmail] = useState(testEmails[0]);
    const [selectedUsername, setSelectedUsername] = useState(testUsernames[0]);
    const [selectedTemplate, setSelectedTemplate] = useState(emailTemplates[0]);
    const [loading, setLoading] = useState(false);

    const handleSend = async () => {
        setLoading(true);
        try {
            const found = emailQueue.find(e => e.template === selectedTemplate);
            const subject = found ? found.subject : 'Test Email from Virtalibry';

            const response = await sendTestEmailApi(
                selectedEmail,
                subject,
                selectedTemplate,
                selectedUsername,
                'Test Title',
                'https://virtalibry.com/',
                123
            );
            alert(`Server Says: ${response.message}`);
        } catch (error) {
            alert(`Failed to send email: ${error.response?.data?.message || error.message}`);
        }
        setLoading(false);
    };

    return (
        <div className="card p-3 shadow-sm">
            <h6 className="mb-3">Test Email Sender (Admin)</h6>
            <Form>
                <Row className="align-items-center g-2">
                    <Col>
                        <Form.Select
                            size="sm"
                            value={selectedEmail}
                            onChange={(e) => setSelectedEmail(e.target.value)}
                        >
                            {testEmails.map((email) => (
                                <option key={email} value={email}>
                                    {email}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col>
                        <Form.Select
                            size="sm"
                            value={selectedUsername}
                            onChange={(e) => setSelectedUsername(e.target.value)}
                        >
                            {testUsernames.map((name) => (
                                <option key={name} value={name}>
                                    {name}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col>
                        <Form.Select
                            size="sm"
                            value={selectedTemplate}
                            onChange={(e) => setSelectedTemplate(e.target.value)}
                        >
                            {emailTemplates.map((template) => (
                                <option key={template} value={template}>
                                    {template}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>
                    <Col xs="auto">
                        <Button
                            size="sm"
                            variant="primary"
                            onClick={handleSend}
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Send'}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default TestEmailSender;
